import React from 'react';
import CommonSearch from '../components/CommonSearch';
import {
    PROJECT_NAME,
    PROJECT_DISPLAY_NAME,
    WARNING_TYPES,
    INFO_TYPES
} from '../config/hotelConfig';

function HotelSearch() {
    return (
        <CommonSearch
            projectName={PROJECT_NAME}
            projectDisplayName={PROJECT_DISPLAY_NAME}
            warningTypes={WARNING_TYPES}
            infoTypes={INFO_TYPES}
        />
    );
}

export default HotelSearch;
